import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location);
  // return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '/',
      redirect: "/index",
      meta: {
        index: 0
      }
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/pages/index.vue'),
      meta: {
        index: 0,
        title: '首页'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/pages/about/index.vue'),
      meta: {
        index: 1,
        title: 'ABOUT BLUE DASH'
      }
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('@/pages/products/index.vue'),
      meta: {
        index: 2,
        title: 'DASH PRODUCTS'
      }
    },
    {
      path: '/culture',
      name: 'culture',
      component: () => import('@/pages/culture/index/index.vue'),
      meta: {
        index: 3,
        title: 'DASH CULTURE'
      }
    },
    {
      path: '/lab',
      name: 'lab',
      component: () => import('@/pages/lab/index.vue'),
      meta: {
        index: 4,
        title: 'DASH LAB'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/pages/contact/index.vue'),
      meta: {
        index: 5,
        title: '联系我们'
      }
    },
    {
      path: '/beats',
      name: 'beats',
      component: () => import('@/pages/culture/beats/index.vue'),
      meta: {
        index: 3,
        title: 'BEATS'
      }
    },
    {
      path: '/night',
      name: 'night',
      component: () => import('@/pages/culture/night/index.vue'),
      meta: {
        index: 3,
        title: 'DASH NIGHT'
      }
    },
    {
      path: '/artist',
      name: 'artist',
      component: () => import('@/pages/culture/artist/index.vue'),
      meta: {
        index: 3,
        title: 'DASH ARTIST'
      }
    },
    {
      path: '/talk',
      name: 'talk',
      component: () => import('@/pages/culture/talk/index.vue'),
      meta: {
        index: 3,
        title: 'DASH TALK'
      }
    },
    {
      path: '/dashLabel',
      name: 'dashLabel',
      component: () => import('@/pages/culture/dashLabel/index.vue'),
      meta: {
        index: 3,
        title: 'DASH LABEL'
      }
    },
    {
      path: '/seeMore',
      name: 'seeMore',
      component: () => import('@/pages/seeMore.vue'),
      meta: {
        index: 3,
        title: 'DASH LABEL'
      }
    },
    {
      path: '/about1',
      name: 'about1',
      component: () => import('@/pages/about.vue'),
      meta: {
        index: 3,
        title: 'DASH LABEL'
      }
    },
    {
      path: '/crossOver',
      name: 'crossOver',
      component: () => import('@/pages/crossOver.vue'),
      meta: {
        index: 3,
        title: 'DASH LABEL'
      }
    },
    // 移动端
    {
      path:"/mobile/index",
      name:"mobileIndex",
      component:()=>import('@/mobilePage/index/index.vue')
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js